import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaLinkedin, FaGithub, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">V</span>
              </div>
              <span className="font-bold text-xl">Versaimmortal</span>
            </div>
            <p className="text-gray-400 mb-4">
              Transforming ideas into digital reality with innovative IT solutions.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition duration-300">
                <FaFacebook className="text-xl" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition duration-300">
                <FaTwitter className="text-xl" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition duration-300">
                <FaLinkedin className="text-xl" />
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition duration-300">
                <FaGithub className="text-xl" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-white transition duration-300">About Us</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white transition duration-300">Services</Link></li>
              <li><Link to="/portfolio" className="text-gray-400 hover:text-white transition duration-300">Portfolio</Link></li>
              <li><Link to="/careers" className="text-gray-400 hover:text-white transition duration-300">Careers</Link></li>
              <li><Link to="/blog" className="text-gray-400 hover:text-white transition duration-300">Blog</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li><Link to="/services#web" className="text-gray-400 hover:text-white transition duration-300">Web Development</Link></li>
              <li><Link to="/services#mobile" className="text-gray-400 hover:text-white transition duration-300">Mobile Apps</Link></li>
              <li><Link to="/services#cloud" className="text-gray-400 hover:text-white transition duration-300">Cloud Solutions</Link></li>
              <li><Link to="/services#security" className="text-gray-400 hover:text-white transition duration-300">Cybersecurity</Link></li>
              <li><Link to="/services#marketing" className="text-gray-400 hover:text-white transition duration-300">Digital Marketing</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              {/* <li className="flex items-start space-x-3">
                <FaMapMarkerAlt className="text-blue-500 mt-1" />
                <span className="text-gray-400">
                  123 Tech Street, Silicon Valley, CA 94025
                </span>
              </li> */}
              {/* <li className="flex items-center space-x-3">
                <FaPhone className="text-blue-500" />
                <a href="tel:+11234567890" className="text-gray-400 hover:text-white transition duration-300">
                  +1 (123) 456-7890
                </a>
              </li> */}
              <li className="flex items-center space-x-3">
                <FaEnvelope className="text-blue-500" />
                <a href="mailto:info@versaimmortal.com" className="text-gray-400 hover:text-white transition duration-300">
                  info@versaimmortal.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            &copy; {new Date().getFullYear()} Versaimmortal Infotech Private Limited. All rights reserved.
          </p>
          <div className="mt-4 space-x-4">
            <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition duration-300">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition duration-300">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;